import { Agent } from './agent';

export class AgentSalesAgent {
	public id: number;
	public salesAgentId: string;
	public rate: number;

	public salesAgent: Agent;

	constructor(agentSalesAgent?: AgentSalesAgent) {
		Object.assign(this, agentSalesAgent);
	}
}
